import React, { type ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
}

export const PlanSection: React.FC<Props> = ({ title, children }) => (
  <section className="flex flex-col">
    <h3 className="text-headline-20 md:text-callout-16 pt-5 pb-3 text-foreground">
      {title}
    </h3>
    {children}
  </section>
);
